import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SentenceFeedbackDialog from './SentenceFeedbackDialog';
import GeneralFeedbackDialog from './GeneralFeedbackDialog';
import SentenceWithTooltip from './SentenceWithTooltip';
import ReactGauge from 'react-gauge-capacity';

const models = {
    news3: {
        types: [     
            {      
                class: 'negative',
                color: '#cd5c5c',
                start: 0,
                end: 45/180,
                value: .125
            },
            {      
                class: 'neutral',
                color: '#c9c989',
                start: 45/180,
                end: 135/180,
                value: .5
            },
            {      
                class: 'positive',
                color: '#3cb371',
                start: 135/180,
                end: 180/180,
                value: .875
            }         
        ]
    },
    financial3: {
        types: [     
            {      
                class: 'negative',
                color: '#cd5c5c',
                start: 0,
                end: 45/180,
                value: .125
            },
            {      
                class: 'neutral',
                color: '#c9c989',
                start: 45/180,
                end: 135/180,
                value: .5
            },
            {      
                class: 'positive',
                color: '#3cb371',
                start: 135/180,
                end: 180/180,
                value: .875
            }         
        ]
    },
    earningsCall: {
        types: [     
            {      
                class: 'negative',
                color: '#cd5c5c',
                start: 0,
                end: 45/180,
                value: .125
            },
            {      
                class: 'neutral',
                color: '#c9c989',
                start: 45/180,
                end: 135/180,
                value: .5
            },
            {      
                class: 'positive',
                color: '#3cb371',
                start: 135/180,
                end: 180/180,
                value: .875
            }         
        ]
    },
    financialTopics: {
        types: [     
            {      
                class: 'negative',
                color: '#cd5c5c',
                start: 0,
                end: 45/180,
                value: .125
            },
            {      
                class: 'neutral',
                color: '#c9c989',
                start: 45/180,
                end: 135/180,
                value: .5
            },
            {      
                class: 'positive',
                color: '#3cb371',
                start: 135/180,
                end: 180/180,
                value: .875
            }         
        ]
    }
};

let contWidth = 250;
let contHeight = 150;
let gaugeRadius = 85;
let centerLineHeight = 120;
 
let options = {
    isInnerNumbers: false, 
    aperture: 180, 
    radius : gaugeRadius,
    tickOffset: 15,
    tickStrokeWidth: 0,
    arcStrokeWidth: 26,
    miniTickLength: 0,
    miniTickStrokeWidth: 0,
    tickLabelOffset: 3,
    scaleDivisionNumber: 5,
    centralCircleRadius: 10,
    marks: ['-', '', '+'],
    contentWidth: contWidth,
    svgContainerWidth: contWidth,
    svgContainerHeight: contHeight,
    gaugeCenterLineHeight: centerLineHeight
}

class SentimentControl extends Component {
    constructor(props) {
        super(props);
        this.handleFeedback = this.handleFeedback.bind(this);

        this.feedbackDisable = window._feedbackDisable;
    }
  
    processSentences() {
        let result = []
        let idx = 0;
        if (this.props.sentences) {
            for (let i = 0; i < this.props.sentences.length; i++) { 
                let sentence = this.props.sentences[i]

                // If we skipped over some text that was not processed in sentiment, add it with
                // no class so it won't get highlighted.
                if (idx < sentence.position[0]) {
                    result.push({
                        'text' : this.props.text.substring(idx, sentence.position[0])
                    })
                }
                idx = sentence.position[1] + 1;

                // Instead of using the text from the sentence given in sentiment, use the offsets into the
                // original text so that we can preserve whitespace characters.
                let formatted_sentence = Object.assign({}, sentence);
                formatted_sentence.text = this.props.text.substring(formatted_sentence.position[0], formatted_sentence.position[1]+1);
                result.push(formatted_sentence)
            }
        }
        return result;
    }

    handleFeedback(sentence) {
        var dlg = this.refs['feedback-dlg'];
        if (dlg && sentence) {
            dlg.open(sentence);
        }
    }

    render() {
        let final_sentences = this.processSentences();
        let self = this;

        options.ranges = models[window._sentimentModel].types;
        options.arrowValue = 0;
        models[window._sentimentModel].types.map((type) => {
                if (type.class == this.props.class) {
                    options.arrowValue = type.value;
                }
            }
        )

        return(
            <div className="sentimentcontrol-wrapper" >
                <div className='tagged-text-sentiment'>
                    <div className="sentiment-legend">
                        <div className="gauge">
                            <ReactGauge {...options} />
                        </div>
                        <div className="overall">
                            The overall document sentiment is <span className={ `${ this.props.class }-sent` }>{ this.props.class }</span> with 
                            a confidence of { this.props.classConfidence.toFixed(4) }.
                            {this.props.score &&  
                                <span> The document sentiment score is {this.props.score.toFixed(4)}.</span> 
                            }<br/> 
                            <br/>
                            The sentiment of each sentence is shown below. Mouse-over a sentence to see its sentiment and confidence score.
                        </div>
                    </div>

                    {!this.feedbackDisable &&
                        <SentenceFeedbackDialog text={this.props.text} results={{
                                class: this.props.class,
                                classConfidence: this.props.classConfidence,
                                sentences: this.props.sentences
                            }} ref="feedback-dlg"/>
                    }
                    <div className="toolbar-container">
                        <button className="link-button" style={{marginRight:'15px'}} onClick={this.props.onReset}>
                            <span className='fa fa-undo'></span>&nbsp;Reset
                        </button>
                        <button className="link-button" style={{marginRight:'15px'}} onClick={this.props.onEdit}>
                            <span className='fa fa-edit'></span>&nbsp;Edit
                        </button>
                        {!this.feedbackDisable &&
                            <div style={{marginRight:'15px'}}>
                                <GeneralFeedbackDialog text={this.props.text} results={{
                                    class: this.props.class,
                                    classConfidence: this.props.classConfidence,
                                    sentences: this.props.sentences
                                }}/>
                            </div>
                        }
                    </div>

                    <div className="sentences">
                    {
                        final_sentences.map(function(sentence, idx) {
                            return <SentenceWithTooltip key={ idx } sentence={ sentence } handleFeedback={self.handleFeedback}/>
                        })
                    }
                    </div>
                </div>
            </div>
        );
    }
};

SentimentControl.propTypes = {
    sentences: PropTypes.array,
    class: PropTypes.string.isRequired,
    classConfidence: PropTypes.number.isRequired,
    score: PropTypes.number.isRequired,
    text: PropTypes.string.isRequired,
    onReset: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired
};

export default SentimentControl;

